// extracted by mini-css-extract-plugin
export default {"formContainer":"user-editor_formContainer__AO8co"};